import { A, useNavigate } from '@solidjs/router'
import { AppSchema } from '/common/types'
import { splitStringAtSentence } from '/web/shared/aifans/lib/string-util'
import { getAssetUrl } from '/web/shared/util'
import { getOrCreateChatWithCharacter } from '/web/shared/aifans/lib/chat-util'
import { abbreviateNumber, getBaseLikes, getViews } from '/web/shared/aifans/lib/model-util'

export default function CreatorSpotlight(props: { creators: AppSchema.Character[] }) {
  const nav = useNavigate()

  return (
    <section class="creators-spotlight pt-16">
      <div class="container">
        <div class="wrapper">
          <div class="top flex flex-col items-center gap-4 py-4 sm:flex-row sm:justify-between">
            <div class="left">
              <h2 class="lg:5xl text-2xl font-bold sm:text-3xl md:text-4xl">
                Creator{' '}
                <span class="bg-spotlight-gradient bg-clip-text text-transparent">Spotlight</span>
              </h2>
            </div>
          </div>

          <div class="content mt-4 grid gap-5 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
            {props.creators.map((creator) => {
              let desc = ''
              if (creator.description) {
                const [firstPart, secondPart] = splitStringAtSentence(creator.description, 15)
                desc = firstPart
              }

              // Usage
              const startDate: string = '2024-11-01'

              const totalViews: string = getViews(creator._id, startDate)

              const baseLikes = getBaseLikes(creator._id)
              const likes = creator.likes ? creator.likes + baseLikes : baseLikes

              return (
                <div class="creator group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl ring-2 ring-transparent transition-all duration-300 hover:ring-primary">
                  <div class="img relative">
                    {creator.avatar && (
                      <A href={`/model/${creator.categorySlug}/${creator.slug || creator._id}`}>
                        <img src={getAssetUrl(creator.avatar)} alt={creator.name} />
                      </A>
                    )}
                    {/* icons */}
                    <div class="icons absolute right-3 top-3 grid gap-2">
                      <div class="relative flex h-[35px] w-[35px] items-center justify-center rounded-full before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-br before:from-secondary before:to-primary before:transition-all before:duration-300 hover:before:rotate-90 hover:before:opacity-50">
                        <button
                          onClick={() =>
                            getOrCreateChatWithCharacter(creator._id, (url) => nav(url))
                          }
                        >
                          <img
                            height={20}
                            width={20}
                            class="relative"
                            src="/images/icons/conversation.png"
                            alt="conversation"
                          />
                        </button>
                      </div>
                      <div class="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-primary duration-300 hover:bg-opacity-50">
                        <A href={`/generate-image/${creator._id}`}>
                          <img
                            height={20}
                            width={20}
                            src="/images/icons/generate.svg"
                            alt="generate"
                          />
                        </A>
                      </div>
                    </div>
                  </div>
                  {/* info */}
                  <A
                    href={`/model/${creator.categorySlug}/${creator.slug || creator._id}`}
                    class="information relative grid flex-grow gap-2 p-3 before:absolute before:inset-0 before:bg-gradient-to-tr before:from-primary before:to-secondary before:opacity-[24%] before:transition-all before:duration-300 group-hover:before:opacity-100"
                  >
                    <div class="top relative flex items-center justify-between gap-2">
                      <h3 class="costume text-2xl font-semibold">{creator.name}</h3>
                      {/* fire icon */}
                      <div class="fire flex h-[47px] w-[47px] items-center justify-center rounded-full bg-gradient-to-b from-cyan/[24%] to-primary/[24%] backdrop-blur-2xl">
                        <img class="h-6 w-6" src="/images/icons/green-fire.svg" alt="green fire" />
                      </div>
                    </div>

                    {/* pera */}
                    <div class="middle relative">
                      <p>{desc}</p>
                    </div>

                    {/* info */}
                    <div class="info relative flex items-center justify-between gap-2 text-sm font-medium text-cyan">
                      <div class="name">{creator.realName}</div>
                      <span class="text-xs text-[#3D3D3D]">|</span>
                      <div class="views">{totalViews} views</div>
                      <span class="text-xs text-[#3D3D3D]">|</span>
                      <div class="likes">{abbreviateNumber(likes)} likes</div>
                    </div>
                  </A>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
